function middlewarePipeline (context, middleware, index) {
    // console.log('Hitting Middleware');
    const nextMiddleware = middleware[index];
    if (!nextMiddleware || nextMiddleware === undefined) {
        return context.next;
    }
    return () => {
        const nextPipeline = middlewarePipeline(
            context, middleware, index + 1
        );
        nextMiddleware({ ...context, next: nextPipeline });
    };
}

export default middlewarePipeline;
